export default "__VITE_ASSET__D37NT5x0__"